import { observer } from 'mobx-react-lite';
import { cdpAiStore } from '../../../stores/cdpAiStore';
import { ActionPreviewCard } from '../ActionPreviewCard';

export const MessageList = observer(() => (
  <div className="flex-1 overflow-y-auto px-3 py-2 space-y-2">
    {cdpAiStore.messages.map((m, i) => {
      if (m.role === 'user') {
        return <div key={i} className="ms-auto max-w-[88%] rounded bg-white/8 px-2 py-1 text-sm">{m.content}</div>;
      }
      if (m.kind === 'text') {
        return <div key={i} className="max-w-[88%] rounded bg-sky-500/10 px-2 py-1 text-sm">{m.content}</div>;
      }
      if (m.kind === 'tool') {
        return <div key={i} className="max-w-[88%] rounded bg-emerald-500/10 px-2 py-1 text-sm">✓ {m.summary}</div>;
      }
      return <div key={i} className="max-w-[88%] rounded bg-rose-500/10 px-2 py-1 text-sm text-rose-200">{m.message}</div>;
    })}
    {cdpAiStore.pendingPreview && (
      <ActionPreviewCard
        actionId={cdpAiStore.pendingPreview.actionId}
        summary={cdpAiStore.pendingPreview.summary}
        affectedCount={cdpAiStore.pendingPreview.affectedCount}
        warnings={cdpAiStore.pendingPreview.warnings}
        destructive={cdpAiStore.pendingPreview.destructive}
        onConfirm={(name) => cdpAiStore.confirm(name)}
        onCancel={() => cdpAiStore.cancel()}
        isLoading={cdpAiStore.isSending}
      />
    )}
  </div>
));
